module.exports = __webpack_public_path__ + "static/media/searchIcon.645243b7.svg";